"use strict";
function getDistanceBetweenPoints(point1, point2) {
    var distance = Math.sqrt(Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2));
    return distance;
}
exports.getDistanceBetweenPoints = getDistanceBetweenPoints;

//# sourceMappingURL=math.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./utilities/math.js
 ** module id = 202
 ** module chunks = 0
 **/